/**
 * @deprecated HeColours deprecated. Use ThemeColours instead
 */
export const HeColours = {
  blue: {
    50: '#E0FCFF',
    100: '#cce8f4',
    200: '#99d1e9',
    300: '#66bbde',
    400: '#33a4d3',
    500: '#0071a0',
    600: '#005578',
    700: '#003850',
    800: '#042840',
    900: '#051e2a',
  },
  teal: {
    50: '#DCF7F7',
    100: '#97E8E8',
    200: '#73E1E1',
    300: '#18CDCD',
    400: '#04B9B9',
    500: '#04838C',
    600: '#03676E',
    700: '#06454E',
  },
  green: {
    50: '#dff2d2',
    100: '#bde5a3',
    200: '#9bd871',
    300: '#77ca3a',
    400: '#48b400',
    500: '#419b00',
    600: '#317700',
    700: '#1e5200',
  },
  yellow: {
    50: '#FFFAF0',
    100: '#fff0cc',
    200: '#ffe299',
    300: '#ffd366',
    400: '#ffc533',
    500: '#cc9200',
    600: '#855900',
    700: '#664900',
  },
  orange: {
    50: '#FFF3EF',
    100: '#FFCFBE',
    200: '#FA9A70',
    300: '#ED5316',
    400: '#D73D00',
    500: '#C22809',
    600: '#AE1400',
    700: '#7B0A0A',
  },
  red: {
    50: '#FFE4EF',
    100: '#f8ced9',
    200: '#f29eb3',
    300: '#eb6e8d',
    400: '#e53e67',
    500: '#b20b34',
    600: '#850827',
    700: '#59051a',
  },
  brown: {
    50: '#F6F0EA',
    100: '#EBE0DB',
    200: '#D2BBB0',
    300: '#B18977',
    400: '#99644C',
    500: '#744C3A',
    600: '#5C3C2E',
    700: '#3D281E',
  },
  gray: {
    50: '#FAFAFA',
    100: '#F3F4F4',
    200: '#E6E9E9',
    300: '#CDD3D4',
    400: '#C2CBCC',
    500: '#A9B3B5',
    600: '#6A7B7D',
    700: '#394F51',
    800: '#1C3434',
    900: '#072326',
    1000: '#011414',
  },
  white: '#ffffff',
  black: '#011414',
} as const;

export interface ColourScale {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
}
